// Libs
import axios from 'axios'

// Actions
import { signOut } from '../Deauth/actions'

// Axios
import { serverAPI } from '../../index'

// Action types
export const CHANGE_FILES = 'change_files'
export const ADD_FILES = 'add_files'

export const changeFiles = (files) => {
  return {
    type: CHANGE_FILES,
    payload: files
  }
}

export const addFiles = (files) => {
  return {
    type: ADD_FILES,
    payload: files
  }
}

export const fetchFiles = (caseId) => {
  return dispatch => {
    serverAPI.get(`/case/drive/${caseId}`)
      .then(response => {
        const { data } = response

        dispatch(changeFiles(data))
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            dispatch(signOut())
            break
          default:
        }
      })
  }
}

export const uploadFiles = (files, caseId, user) => {
  return dispatch => {
    let filesToUpload = []

    files.map(file => {
      const randomId = Math.floor(Math.random() * 90000) + 10000
      const fileToUpload = { id: randomId, real_name: file.name, user, uploadedAt: null }
      filesToUpload = [...filesToUpload, fileToUpload]

      let formData = new FormData();
      formData.append('caseId', caseId)
      formData.append('file', file)

      serverAPI.post(`/case/drive/upload`, formData)
        .then(response => {
          dispatch(fetchFiles(caseId))
        })
        .catch(e => {
          switch (e.response.status) {
            case 401:
              dispatch(signOut())
              break
            default:
          }
        })
    })

    dispatch(addFiles(filesToUpload))
  }
}
